import React, { useState, useEffect } from "react"
import {
  Modal,
  ModalBody,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { loginUser } from "../../store/actions"
import { useLock } from "./lockcontext"
import { useNavigate } from "react-router-dom"
import "./LockScreen.scss"

const LockScreen = ({ isOpen }) => {
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [localUser, setLocalUser] = useState({ fname: "", lname: "" })
  const [email, setEmail] = useState("")

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { unlockScreen } = useLock()

  const loginError = useSelector(state => state.Login?.error)

  useEffect(() => {
    const storedUser = localStorage.getItem("user")
    const emailFromStorage = localStorage.getItem("email")

    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser)
        setLocalUser({
          fname: parsed.fname || "",
          lname: parsed.lname || "",
        })
        setEmail(parsed.email || emailFromStorage || "")
      } catch (err) {
        console.error("Invalid user data in localStorage")
      }
    } else {
      setEmail(emailFromStorage || "")
    }
  }, [isOpen])

  useEffect(() => {
    if (loginError) setError(loginError)
  }, [loginError])

  const handleUnlock = e => {
    e.preventDefault()
    if (!password) {
      setError("Please enter your password")
      return
    }

    
    dispatch(
      loginUser({
        user: { email: email.trim(), password: password.trim() },
        callback: () => {
          unlockScreen()
          setPassword("")
          setError("")
          const userData = JSON.parse(localStorage.getItem("user"))
          if (userData) {
            setLocalUser({
              fname: userData.fname || "",
              lname: userData.lname || "",
            })
          }
        },
        history: navigate,
      }),
    )
  }

  const handleLoginWithDifferentAccount = () => {
    localStorage.removeItem("authToken")
    localStorage.removeItem("email")
    localStorage.removeItem("user")
    localStorage.removeItem("isLocked")
    window.location.href = "/login"
    navigate("/login")
  }

  const getInitials = (firstName, lastName) => {
    const firstInitial = firstName?.[0]?.toUpperCase() || ""
    const lastInitial = lastName?.[0]?.toUpperCase() || ""
    return `${firstInitial}${lastInitial}`
  }

  return (
    <>
      {isOpen && <div className="modal-gray-overlay" />}

      <Modal isOpen={isOpen} centered backdrop="static">
        <ModalBody className="text-center p-4">
          <div className="avatar-circle mb-3">
            <span className="initials">
              {getInitials(localUser.fname, localUser.lname)}
            </span>
          </div>

          <h5>
            Hello {localUser.fname} {localUser.lname}, please enter your
            password to unlock!
          </h5>

          <Form onSubmit={handleUnlock} className="mt-3">
            <FormGroup>
              <Label>Password</Label>
              <Input
                type="password"
                value={password}
                placeholder="Enter your password"
                onChange={e => setPassword(e.target.value)}
              />
            </FormGroup>
            {error && <div className="text-danger">{error}</div>}
            <Button color="primary" className="mt-2 w-100" type="submit">
              Unlock
            </Button>

            <Button
              color="secondary"
              className="mt-2 w-100"
              onClick={handleLoginWithDifferentAccount}
            >
              Login with different Account
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </>
  )
}

export default LockScreen
